import { ConstantsCodeType } from 'src/types/constantsCodes';

const productTypesWithoutVirtual = (productTypeCodes: ConstantsCodeType[]) =>
    productTypeCodes.filter((item) => item.value !== 'virtual');

export default productTypesWithoutVirtual;
